<div class="year-box">
  <p class="yearLabel">Start-End Year</p>
  <div class="mdlz-yrp-container">
    <div (click)="showCalendar = !showCalendar;" class="mdlz-yrp-picker-box">
      <div class="mdlz-yrp-picker-text">
        <img src="../../../../../../assets/images/calendar_today.svg" alt="Calendar Icon"
             class="mdlz-yrp-calendar-icon" width="15px" height="18px"/>
        <span class="timeframedate">{{selectedYears.length > 0 ? displayTimeFrame() : 'Select Timeframe'}}</span>
      </div>
    </div>
  </div>
  <!--  <div *ngIf="showCalendar" class="mdlz-yrp-options-container">-->
  <!--    <div class="year-row" *ngFor="let row of yearRows; let rowIndex = index">-->
  <!--      <div class="year-cell" *ngFor="let year of row" [class.selected]="isYearSelected(year)"-->
  <!--           (click)="toggleYearSelection($event,year, rowIndex)">-->
  <!--        {{ year }}-->
  <!--      </div>-->
  <!--    </div>-->
  <!--  </div>-->
  <div *ngIf="showCalendar" class="mdlz-yrp-options-container">
    <div class="mdlz-yrp-options-column">
      <div class="mdlz-yrp-options-cell">
        Start
      </div>
      <div class="mdlz-yrp-options-cell" *ngFor="let yearCell of years;"
           [ngClass]="{ 'mdlz-yrp-options-selected': yearCell == this.selectedStartYear,
           'mdlz-yrp-options-disabled': yearCell > this.selectedEndYear}"
           (click)="selectYear('selectedStartYear', yearCell)">
        {{yearCell}}
      </div>
    </div>
    <div class="mdlz-yrp-options-column">
      <div class="mdlz-yrp-options-cell">
        End
      </div>
      <div class="mdlz-yrp-options-cell" *ngFor="let yearCell of years;"
           [ngClass]="{ 'mdlz-yrp-options-selected': yearCell == this.selectedEndYear,
            'mdlz-yrp-options-disabled': yearCell < this.selectedStartYear}"
      (click)="selectYear('selectedEndYear', yearCell)">
        {{yearCell}}
      </div>
    </div>
  </div>
</div>
